<template>
  <v-container grid-list-md fluid class="pa-0 grey lighten-4 pa-2 card-r">
      <v-layout>
        <v-flex>
          <v-img size="36px" v-bind:src="studentdetails.cover_image" class="CoverPhoto card-r"></v-img>
          <v-btn icon v-bind:to="'/students/profile/edit/'+studentdetails.id" flat color="grey" class="text-xs-right right ma-0 shadow-1"><v-icon>edit</v-icon></v-btn>

        </v-flex>
      </v-layout>
      <v-layout row class="text-xs-center" v-if="studentdetails">

        <v-flex xs12 class="profileImgd" v-bind:src="studentdetails.image">
          <v-img v-bind:src="studentdetails.image" class="boxShadow"></v-img>
        </v-flex>
      </v-layout>
      <v-container fluid grid-list-xl v-if="studentdetails" class="pt-0 pb-0 grey lighten-4 card-r ">
        <v-layout row wrap class="pb-3">
          <v-flex d-flex lg12 sm12 xs12>
            <div class="text-xs-center">
              <span class="headline font-weight-black text-capitalize">{{studentdetails.name}}</span> <br>
              <p class="text-xs-center">
                A student is a learner, or someone who attends an educational
                institution. ... In its widest use, student is used for anyone who is learning
              </p>
            </div>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shadow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p> Full Name </p> </v-flex>
                <v-flex xs6 class="text-xs-right word-break pa-0">{{studentdetails.name}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards w-100 pa-0  shadow-1 card-r">
              <v-layout row class="ma-0">
                <v-flex xs2 class="label pa-0"><p>Email</p> </v-flex>
                <v-flex xs10 class="scroll-y text-xs-right word-break pa-0">{{studentdetails.email}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shadow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p>Phone Number</p> </v-flex>
                <v-flex xs6 class="text-xs-right word-break pa-0">+45{{studentdetails.phone}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shadow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p>Date of Birth</p> </v-flex>
                <v-flex xs6 class="text-xs-right word-break pa-0">{{studentdetails.dob}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shadow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs3 class="label pa-0"><p>Address</p> </v-flex>
                <v-flex xs9 class="text-xs-right word-break pa-0">krt7inkfguybh</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shadow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p>City</p> </v-flex>
                <v-flex xs6 class="text-xs-right word-break pa-0" v-if="studentdetails.city">{{studentdetails.city}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shadow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p>State</p> </v-flex>
                <v-flex xs6 class="text-xs-right word-break pa-0">krt7inkfguybh</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shadow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p>Postal Code</p> </v-flex>
                <v-flex xs6 class="text-xs-right word-break pa-0" v-if="studentdetails.zipCode">{{studentdetails.zipCode}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shadow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p>Gender</p> </v-flex>
                <v-flex xs6 class="text-xs-right word-break pa-0">{{studentdetails.gender}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
        <v-dialog v-model="dialog" max-width="500px">
                <v-card class="pa-2 card-r mb-2 grey lighten-4">
                <v-toolbar class="primary darken-2 card-r shadow-1 pl-3 text-white">
                 <div class="text-xs-left f-20">Change Teacher</div>
                </v-toolbar>
                  <v-card-text class="pa-0 mt-2">
                  <div v-if="!loading">
                    <v-alert
                      :value="true"
                      v-if="msgType=='success'"
                      color="success"
                      icon="check_circle"
                      outline
                    >
                      {{msg}}
                    </v-alert>
                    <v-alert
                      :value="true"
                      v-if="msgType=='warning'"
                      color="error"
                      icon="warning"
                      outline
                    >
                      {{msg}}
                    </v-alert>
                  </div>
                  <v-progress-circular
                    v-if="loading"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                  <div>
                      Your Teacher : <span v-if="studentTeacherdetails.teacher"><code>{{studentTeacherdetails[0].teacher.name}}</code> </span>
                      <v-select solo
                          :items="TeachersData"
                          label="Change to"
                          placeholder="teacher Name"
                          item-value="id"
                          item-text="name"
                          v-model="newTeacherId"
                      ></v-select>
                  </div>
                  </v-card-text>
                  <v-card-actions >
                   <div class="text-xs-right w-100 mr-2">
                     <v-btn color="grey" class="card-r text-white text-xs-right" @click="dialog=false">Close</v-btn>
                     <v-btn color="primary" class="card-r text-white primary darken-2" @click="changeTeacher(newTeacherId)">Change</v-btn>
                   </div>
                  </v-card-actions>
                </v-card>
         </v-dialog>
    <v-container grid-list-md fluid class="pt-0">
    <span v-if="studentdetails">
      <v-btn v-if="!studentdetails.teacher" flat class="ma-0 card-r tow-clor-grey text-white mt-2 mb-2" @click="dialog = true">Add Teacher</v-btn>
    </span>

    <v-card xs12 class="grey lighten-4 no-shadow card-r" v-if="studentTeacherdetails" v-for="n in studentTeacherdetails">
        <div v-if="n.teacher">
          <v-flex xs6 class="pt-0">
            <div class="f-20 textColor font-weight-bold text--primary">{{studentdetails.name}} 's Teachers</div>
          </v-flex>
        <v-layout row wrap class="">
          <v-flex xs12 lg4 sm12>
            <!--<div class="f-15 text-xs-left text-primary">Package Name</div>-->
            <v-btn flat class="ma-0 card-r tow-clor-grey text-white mt-2 mb-2" @click="dialog = true">Change Teacher</v-btn>


            <v-card class="pa-2 shadow-1 card-r grey lighten-5">
             <v-layout class="">
               <v-flex>
                 <v-img :src="TcoverPhoto" class="CoverPhoto card-r"></v-img>
               </v-flex>
             </v-layout>
             <v-layout row wrap class="text-xs-center">
               <v-flex xs12 class="img-s-profile-tea " v-if="n.teacher">
                 <v-img v-bind:src="n.teacher.image_path" class="no-shadow"></v-img>
                 <span class="f-15 font-weight-black text--primary text-capitalize">{{n.teacher.name}}</span> <br>
                 <v-btn v-show="!seen" @click="seen = !seen" flat small class="text-primary text-capitalize">ReadMore</v-btn>
                 <v-btn v-show="seen" @click="seen = !seen" flat small class="text-grey text-capitalize">Less</v-btn>
                 <div v-show="seen">
                   <span class="f-12  text--secondary text-capitalize">
                        Teachers create lesson plans and teach those plans to the entire class, individually to
                          students or in small groups, track student progress and present the information to parents,
                          create tests, create and reinforce classroom rules, work with school administration prepare
                          students for standardized tests, and manage ...
                          </span> <br>
                   <v-container fluid grid-list-xl class="pa-0">
                     <v-layout row wrap class="">
                       <v-flex d-flex lg12 sm6 xs12 class="pb-0">
                         <v-card class="PersonalCards studet pa-0 shadow-1 card-r">
                           <v-layout row class="ma-0 ">
                             <v-flex xs2 class="label pa-0"><p> Email </p> </v-flex>
                             <v-flex xs10 class="text-xs-right word-break pa-0">{{n.teacher.email}}</v-flex>
                           </v-layout>
                         </v-card>
                       </v-flex>

                       <v-flex d-flex lg12 sm6 xs12 class="pb-0">
                         <v-card class="PersonalCards studet pa-0 shadow-1 card-r">
                           <v-layout row class="ma-0 ">
                             <v-flex xs5 class="label pa-0"><p> Phone number </p> </v-flex>
                             <v-flex xs7 class="text-xs-right word-break pa-0">+45 {{n.teacher.phone}}</v-flex>
                           </v-layout>
                         </v-card>
                       </v-flex>
                       <v-flex d-flex lg12 sm6 xs12 class="pb-0">
                         <v-card class="PersonalCards studet pa-0 shadow-1 card-r">
                           <v-layout row class="ma-0 ">
                             <v-flex xs6 class="label pa-0"><p> Date of Birth </p> </v-flex>
                             <v-flex xs6 class="text-xs-right word-break pa-0">{{n.teacher.dob}}</v-flex>
                           </v-layout>
                         </v-card>
                       </v-flex>
                       <v-flex d-flex lg12 sm6 xs12 class="">
                         <v-card class="PersonalCards studet pa-0 shadow-1 card-r">
                           <v-layout row class="ma-0 ">
                             <v-flex xs6 class="label pa-0"><p> Gender </p> </v-flex>
                             <v-flex xs6 class="text-xs-right word-break pa-0">{{n.teacher.gender}}</v-flex>
                           </v-layout>
                         </v-card>
                       </v-flex>
                     </v-layout>
                   </v-container>
                 </div>
               </v-flex>
             </v-layout>
           </v-card>
          </v-flex>
        </v-layout>
        </div>
      </v-card>
    </v-container>
    </v-container>
</template>

<script>
  /* eslint-disable */
  import { mapState, dispatch } from "vuex";
  import { log } from 'util';
  import api from "../../../utils/backend-api.js"
  export default {
    // name: "personal",
    data: () => ({
      seen: false,
      TeachersData:[],
      newTeacherId:'',
      dialog:false,
      loading:false,
      msg:'',
      msgType:'',
      coverPhoto: "https://cdn.edarabia.com/wp-content/uploads/2017/06/university-of-bolton-acerak-driving-student-centered-learning-and-development.jpg",
      TcoverPhoto: "https://s3.amazonaws.com/stg-drivers-license-assistance.org/images/blog/find-driving-teacher.jpg",
      ProfileImg: "https://greatertulsadrivingschool.files.wordpress.com/2012/09/image_oregon-driver-education-center-2_grid_6.jpg",
      TProfileImg: "https://cdn.vuetifyjs.com/images/lists/2.jpg"
    }),

    //   computed:{
    //   user(){
    //     return this.$session.get("user")
    //     // return this.$store.getters.getUser
    //   }
    // },
    props:['id'],
    created() {
      this.studentId = this.$route.params.id;
      console.log("Created")
    Store.dispatch("Students/getStudentById", this.studentId)
      this.studentId = this.$route.params.id;
      Store.dispatch("Students/getStudentTeacherById", this.studentId)
      this.TeachersData=Store.state.teacherData
    },
    computed: {
      ...mapState({
        studentdetails: Students => Store.state.Students.studentdetails,
        studentTeacherdetails: Students => Store.state.Students.studentTeacherdetails
      })
    },
    methods:{
      initialize(){
          this.dialog=true
          this.msg=""
          this.msgType=""
      },
      changeTeacher(newTeacherId){
        var studentId=this.$route.params.id
        var bookedId
        var packageId
        api.getData("admin/student_package/"+studentId)
        .then(res=>{
          bookedId=res.data[0].id
          packageId=res.data[0].package_id
          var data={
            package_id:packageId,
            teacher_id:newTeacherId
          }
              api.postData("admin/student_package/"+bookedId,data)
              .then(res=>{
                if(res.status==201){
                  this.msg="Teacher Successfully Changed"
                  this.msgType="success"
                  setTimeout(() => {
                    this.dialog=false
                  }, 2000);
                  Store.dispatch("Students/getStudentTeacherById", studentId).then(res => {
                  });
                  this.TeachersData=Store.state.teacherData
                }else{
                  this.msg="Failed to change teacher"
                  this.msgType="warning"
                }
              })
              .catch(err=>{
                this.msg="Failed to change teacher"
                  this.msgType="warning"
              })
        }).catch(err=>{
          this.msgType="warning"
          this.msg="There is no any package for student"
        })
      }
    },

  };
</script>



// WEBPACK FOOTER //
// src/components/profile/student/StudentPersonal.vue